import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Notice from './Notice'

const OfflineNotice = ({ offline }) => (
  <Notice show={offline} title={__('Network Connection Lost')}>
    {__(
      'You are offline. Check your connection, and as soon as connection is reestablished, please refresh the page.',
    )}
  </Notice>
)

OfflineNotice.propTypes = {
  offline: PropTypes.bool,
}

export default connect(({ offline }) => ({ offline }))(OfflineNotice)
